<template>
    <v-list-item
        component="ShortlistCharacterListItem"
        :class="[
            { isSmallScreen: getIsSmallScreen },
            { isSmallerScreen: getIsSmallerScreen },
            { confirm: removeConfirm },
            { closed: !canEditProject },
        ]"
    >
        <div class="number">{{ index + 1 }}</div>

        <div class="name" :title="candidate.meno_priezvisko">
            <span class="text">{{ candidate.meno_priezvisko }}</span>
        </div>

        <div class="actions">
            <div class="icon sent" v-if="hasEmailRequest && !hasPlayableVideos">alternate_email</div>

            <v-btn v-if="hasPlayableVideos" icon @click="showRecording">
                <v-icon>videocam</v-icon>
            </v-btn>

            <mp3-player
                :state="!candidate.mp3 ? 'error' : ''"
                class="sample"
                :file="getSampleMp3Url(candidate.mp3)"
                :size="getIsSmallerScreen ? 'smaller' : 'small'"
                :visualizer="'project'"
            ></mp3-player>

            <mp3-player
                :state="!candidate.mp3_biblia ? 'error' : ''"
                class="sample"
                :file="getSampleMp3Url(candidate.mp3_biblia)"
                :size="getIsSmallerScreen ? 'smaller' : 'small'"
                :visualizer="'project'"
            ></mp3-player>

            <btn
                :icon="'close'"
                v-if="canEditProject"
                :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                color="transparent"
                @click="removeConfirm = true"
            />
        </div>

        <div
            class="warning"
            :class="{ show: removeConfirm }"
            :style="{ background: `linear-gradient(90deg, transparent, ${charColor} 40%)!important` }"
        >
            <div class="label">Remove voice?</div>
            <btn
                :icon="'close'"
                color="ghost"
                for-background="dark"
                :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                @click.stop="removeConfirm = false"
            />
            <btn
                :icon="'check'"
                color="ghost"
                for-background="dark"
                :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                @click.stop="removeFromList(index)"
            />
        </div>
    </v-list-item>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import '@/utils/moveableDialog.js';

export default {
    name: 'ShortlistCharacterListItem',

    props: {
        candidateIn: {},
        character: null,
        index: null,
    },

    data() {
        return {
            removeConfirm: false,
            candidate: {},
        };
    },

    created() {
        this.candidate = this.candidateIn;
        this.$_eventsSubscribe({ projectLoaded: 'reloadEmailRequest' });
    },

    async mounted() {
        this.loading = false;
    },

    beforeDestroy() {
        this.$_eventsUnsubscribe();
    },

    methods: {
        ...mapMutations(['setProjectVideoListDialog']),

        reloadEmailRequest() {
            // This is stupid but works
            if (this.hasEmailRequest && this.getEmailRequest?.id == this.getProjectVideoListDialog?.emailRequest?.id) {
                this.setProjectVideoListDialog({ emailRequest: this.getEmailRequest });
            }
        },

        async showRecording() {
            if (this.getEmailRequest) {
                this.setProjectVideoListDialog({ visible: true, emailRequest: this.getEmailRequest });
            }
        },

        removeFromList(index) {
            this.$emit('removeFromList', { index: index, candidate: this.candidate });
        },
    },

    computed: {
        ...mapGetters([
            'getSampleMp3Url',
            'canEditProject',
            'getColorById',
            'getIsSmallScreen',
            'getIsSmallerScreen',
            'getProjectVideoListDialog',
        ]),

        charColor() {
            return this.getColorById(this.character.farba);
        },

        getEmailRequest() {
            return this.character?.video_request?.email_requests.find((i) => i.actor_id == this.candidate.id) || null;
        },

        hasEmailRequest() {
            return !!this.getEmailRequest;
        },

        hasPlayableVideos() {
            return (this.hasEmailRequest && this.getEmailRequest?.videos?.some((i) => i.converted_at)) || false;
        },
    },

    components: {
        draggable,
        Mp3Player,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ShortlistCharacterListItem'] {
    overflow: hidden;
    border-top: 1px solid fade(white, 40%);
    padding: 0 8px 0 0;
    min-height: 40px;
    height: 40px;
    cursor: move;

    &.closed {
        cursor: default;
    }

    &.isSmallerScreen {
        min-height: 33px;
        height: 33px;

        .name {
            font-size: 13px;
        }
    }

    &:before {
        .fullFillBground;
        background-color: white;
        opacity: 0.2;
        pointer-events: none;
        transition: 0.3s;
    }

    &:hover {
        &:before {
            opacity: 0;
        }
    }

    .number {
        .flex-center;
        font-weight: bold;
        font-size: 11px;
        min-width: 25px;
        height: 100%;
        background-color: fade(white, 50%);
        border-right: 1px solid fade(white, 30%);
        margin-right: 10px;
        position: relative;
        z-index: 2;
    }

    .name {
        padding: 0;
        margin: 0;
        transition: opacity 0.2s ease-in-out;
        align-items: center;
        display: flex;
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        z-index: 2;

        .text {
            text-overflow: ellipsis;
            width: 100%;
            overflow: hidden;
        }
    }

    .actions {
        .flex-row;
        justify-content: flex-end;
        min-height: 40px;
        position: relative;
        margin: 0;
        margin-left: auto;
        z-index: 4;

        .icon.sent {
            margin-right: 5px;
            color: fade(@black, 50%);
            font-size: 18px;
        }
    }

    .warning {
        .flex-row;
        justify-content: flex-end;
        position: absolute;
        right: 0;
        height: 100%;
        width: 100%;
        z-index: 6;
        transition: 0.3s;
        transform: translateX(110%);
        padding: 10px 10px 10px 30px;

        &.show {
            transform: translateX(0);
        }

        .label {
            font-weight: 700;
            color: white;
            margin-right: 10px;
        }

        button {
            margin-left: 3px;
        }
    }

    &.confirm {
        .name {
            opacity: 0.3;
        }
    }
}
</style>
